import {makeAutoObservable, observable} from 'mobx';

import {MatchFavourite, sortByCreatedAtDesc} from '@/domain';

class FavoritedStore {
  list = observable.array<MatchFavourite>([], {deep: false});
  count = 0;
  fetchedAllFavourites = false;

  constructor() {
    makeAutoObservable(this);
  }

  get hasFavourites() {
    return this.count > 0;
  }

  get empty() {
    return this.list.length === 0 && this.fetchedAllFavourites;
  }

  get lastFavourite() {
    return this.list[0];
  }

  get lastLoadedFavouriteAt() {
    return this.list[this.list.length - 1]?.created_at;
  }

  setCount(count: number) {
    this.count = Math.max(0, count);
  }

  setFetchedAllFavourites(fetched: boolean) {
    this.fetchedAllFavourites = fetched;
  }

  addFavourites(list: MatchFavourite[]) {
    if (list.length === 0) {
      return;
    }

    const existedIds = new Set(this.list.map((item) => item.id));
    const nextItems = list.filter((item) => !existedIds.has(item.id));
    if (nextItems.length === 0) {
      return;
    }

    this.list.replace([...this.list, ...nextItems].sort(sortByCreatedAtDesc));
  }

  addFavourite(favourite: MatchFavourite) {
    this.addFavourites([favourite]);
  }

  removeFavourite(favouriteId: number) {
    this.list.replace(this.list.filter((item) => item.id !== favouriteId));
  }

  removeByMatchId(matchId: number) {
    const nextList = this.list.filter((item) => item.match_id !== matchId);
    const removedCount = this.list.length - nextList.length;

    if (removedCount === 0) {
      return;
    }

    this.list.replace(nextList);
    this.count = Math.max(0, this.count - removedCount);
  }

  resetList() {
    this.list.clear();
    this.fetchedAllFavourites = false;
  }

  reset() {
    this.list.clear();
    this.count = 0;
    this.fetchedAllFavourites = false;
  }
}

export const favoritedStore = new FavoritedStore();
